import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Sidebar } from '../../../components/sidebar';
import { EditProfileModal, type Profile } from '../../profiles-tracking/components/edit-profile-modal';
import { PostsTab } from '../../profiles-tracking/components/edit-profile-modal/components';
import { profilesTrackingService } from '../../profiles-tracking/services';
import { homeService } from '../../home/services';
import { useEditProfileModal } from '../../../contexts/useEditProfileModal';
import { useUserStore, canEditSelectedProfile } from '../../../store/user';
import { profileIdDoUsuario } from '../../reviews/services';
import { PostsContainer, MainContent } from './styles';

/**
 * Postagens do cliente com dados reais do Google: o mesmo painel que a
 * equipe usa na aba Postagens do editor. Até 30/09/2026 esta página mostrava
 * dados de exemplo fixos.
 */
export const PostsPage: React.FC = () => {
  const { isOpen: isEditModalOpen, closeModal } = useEditProfileModal();
  const [profileData, setProfileData] = useState<Profile | null>(null);
  const { user } = useUserStore();
  const canEdit = canEditSelectedProfile(user);
  const profileId = profileIdDoUsuario(user?.businessProfiles?.[0]);

  // Dados reais do perfil (nome, categoria, cidade) para o editor, como na Home.
  useEffect(() => {
    if (!user || !profileId) return;
    let ativo = true;
    const base: Profile = {
      id: profileId,
      name: user.name || "",
      category: "Cliente",
      status: "active" as const,
      stats: { views: 0, clicks: 0, ranking: 0 },
    };
    setProfileData(base);
    homeService
      .getProfileDetails(profileId)
      .then((details) => {
        if (ativo && details) setProfileData({ ...base, ...(details as Profile) });
      })
      .catch(() => undefined);
    return () => {
      ativo = false;
    };
  }, [user, profileId]);

  const handleSaveProfile = async (updatedProfile: Profile) => {
    try {
      await profilesTrackingService.updateProfile(updatedProfile.id, updatedProfile);
      setProfileData(updatedProfile);
      toast.success('Perfil atualizado com sucesso!');
    } catch (error) {
      toast.error('Erro ao atualizar perfil');
      console.error(error);
      throw error;
    }
  };

  return (
    <PostsContainer>
      <Sidebar />
      <MainContent>
        <div className="margem-da-pagina" style={{ padding: '32px 40px 16px', display: 'flex', flexDirection: 'column', gap: 6 }}>
          <h1 style={{ margin: 0, fontFamily: 'var(--font-sans)', fontSize: 32, lineHeight: '40px', fontWeight: 500, color: '#1F1F1F' }}>Postagens</h1>
          <span style={{ fontSize: 14, lineHeight: '20px', color: '#5F6368' }}>
            Crie publicações na ficha do Google e acompanhe o que já está no ar. As ideias da IA usam o seu gabarito; você aprova antes de publicar.
          </span>
        </div>
        {profileId ? (
          <div className="margem-da-pagina" style={{ padding: '0 40px 40px' }}>
            <PostsTab profile={profileData} readOnly={!canEdit} />
          </div>
        ) : (
          <div style={{ padding: '60px 20px', textAlign: 'center', color: '#5F6368' }}>
            Nenhum perfil selecionado. Escolha um perfil para ver as postagens.
          </div>
        )}
      </MainContent>

      <EditProfileModal
        isOpen={isEditModalOpen}
        profile={profileData}
        onClose={closeModal}
        onSave={handleSaveProfile}
        hideIATab={true}
      />
    </PostsContainer>
  );
};

export default PostsPage;
